import * as t from "io-ts";
import { DetermineTypeHelper } from "../../helpers/determine-type.helper.js";
// #endregion Interfaces (1)
// #region Functions (2)
export function createSearchKey(field, value, operator) {
  try {
    const fieldValue = {
      field: field,
      value: value,
      operator: operator,
      type: DetermineTypeHelper.getType(value).toString()
    };
    return fieldValue;
  } catch (err) {
    console.error("ERROR CREATING SEARCH KEY", err);
    throw err;
  }
}
export function isCommonSearchKey(value) {
  const tag = ICommonSearchKeyType.decode(value)._tag;
  const result = tag === "Right";
  return result;
}
// #endregion Functions (2)
// #region Variables (1)
export const ICommonSearchKeyType = t.type({
  field: t.string,
  value: t.any,
  type: t.any
});
// #endregion Variables (1)